export enum ELoanProductConsultStep {
  FORM = 'FORM',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  COMMUNICATION_METHOD = 'COMMUNICATION_METHOD',
}
